var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSortDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9958 12H6.9958L6.9958 3.38074L8.4379 4.84994C8.53006 4.94538 8.65621 4.99916 8.7879 4.99916C8.91959 4.99916 9.04573 4.94538 9.1379 4.84994L9.8479 4.12955C9.94255 4.03429 9.9958 3.90462 9.9958 3.76935C9.9958 3.63409 9.94255 3.50442 9.8479 3.40916L6.7179 0.223219C6.57618 0.082303 6.38631 0.00233746 6.1879 0H5.8079C5.60905 0.000177383 5.41841 0.0804682 5.2779 0.223219L2.1479 3.40916C2.05324 3.50442 2 3.63409 2 3.76935C2 3.90462 2.05324 4.03429 2.1479 4.12955L2.8479 4.84994C2.94178 4.94598 3.06958 5 3.2029 5C3.33622 5 3.46401 4.94598 3.5579 4.84994L4.9958 3.38502L4.9958 12Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSortDesc);
export default __webpack_public_path__ + "static/media/arrow-sort-desc.bda26afca03e0cedbf573d600b062291.svg";
export { ForwardRef as ReactComponent };